Px.CMS.PhotoPrintsComponent.Integrations.Shopify = {

  name: 'shopify',

  postMessage: function(type, data) {
    window.parent.postMessage({pixfizz: true, type: type, data: data || {}}, '*');
  },

  createProjectExtraParams: function(print_product) {
    if (!print_product.sku) {
      console.error('Design product definition is missing the sku field', mobx.toJS(print_product));
      throw new Error('Design product does not have a sku');
    }

    const shopify_product_id = Px.urlQuery().shopify_product_id;
    if (!shopify_product_id) {
      throw new Error('shopify_product_id is not set');
    }

    const shopify_variant_id = Px.CMS.PhotoPrintsComponent.Integrations.Shopify.getShopifyVariantId(print_product.sku);
    if (!shopify_variant_id) {
      throw new Error('shopify_variant_id not set');
    }

    return {
      'custom[shopify_product_id]': shopify_product_id,
      'custom[shopify_variant_id]': shopify_variant_id
    };
  },

  getShopifyVariantId: function(pixfizz_sku) {
    const sku_map = JSON.parse(Px.urlQuery().shopify_sku_map);
    let shopify_variant_id;
    Object.entries(sku_map).forEach(entry => {
      if (entry[1] === pixfizz_sku) {
        shopify_variant_id = entry[0];
      }
    });
    return shopify_variant_id;
  }

};
